import { createContext as t, useContext as o } from "react";
const e = t({ gap: 0, gridCols: 12 }), n = () => o(e);
export {
  e as GridContext,
  n as useGrid
};
